import { Service, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CompanyDataService } from '@data-services/companies';
import { Company } from '@models/companies';
import { DataContext } from '@services/data-context';
import { createPageResource } from '@utils';

@Service({ autoProvided: false })
export class CompaniesService {
  private readonly companyDataService = inject(CompanyDataService);
  private readonly dataContext = inject(DataContext);
  private readonly route = inject(ActivatedRoute);
  private readonly translate = inject(TranslateService);

  readonly resource = createPageResource<Company[], string>({
    params: () => this.dataContext.projectContext()?.id ?? this.route.snapshot.paramMap.get('projectId') ?? undefined,
    loadAsync: (projectId) => this.companyDataService.getCompaniesAsync(projectId),
    errorMessage: () => this.translate.instant('general.loadCompaniesError'),
    fallbackValue: []
  });

  reload(): void {
    if (!this.resource.isLoading()) {
      this.resource.reload();
    }
  }
}
